import Vue from "vue";
import Router from "vue-router";
import getRoutes from "./filterRoutes";
import store from "../store";
import { Storage } from "@/utils/storage";
import { getToken } from "@/utils/cookie";
import { decrypt } from "@/utils/crypto";
import { showError } from "@/utils";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

// 路由跳转解密query参数
const decryptQuery = ({ query }) => {
  for (const key in query) {
    if (key !== "cached") {
      query[key] = decrypt(query[key]);
    }
  }
};

// 配置加载进度条
NProgress.inc(0.2);
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });
NProgress.done();

Vue.use(Router);
const staticRouters = [
  {
    path: "/login",
    component: () => import("@/views/login"),
    meta: {
      permission: true
    }
  },
  {
    path: "/",
    hidden: true,
    redirect: "/login",
    meta: {
      permission: true
    }
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
    meta: {
      permission: true
    }
  },
  {
    path: "/useInfo",
    component: () => import("@/views/userInfo"),
    hidden: true,
    meta: {
      permission: true
    }
  }
];
const router = new Router({
  routes: staticRouters
});

//去掉跳转重复路由报错的问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location)?.catch(err => err);
};

router.$addRoutes = routes => {
  /*
   *给router添加全局方法，调用该方法重置路由
   *解决切换角色路由重复添加的问题
   */
  router.matcher = new Router({
    // 重置路由规则
    routes: staticRouters
  }).matcher;
  router.addRoutes(routes); // 添加路由
};

window.addEventListener("DOMContentLoaded", () => {
  /*
   *页面刷新时判断角色权限
   */
  if (!getToken()) {
    router.push({ path: "/login" });
  }
});

router.beforeEach(async (to, from, next) => {
  /*
   *切换路由时判断角色权限
   */
  try {
    // 解密路由参数
    decryptQuery(to, false);
  } catch (err) {
    showError("url参数错误");
  }
  NProgress.start();
  if (to.path == "/login") {
    //到登录页面初始化所有权限数据，防止再退回有权限的页面造成错误
    // Storage.remove("fm-menu");
    // removeToken();
    // removeUserId(); 不知道为啥删了node_modules就有问题，暂且放到login.vue里去执行
    next();
  } else {
    if (getToken()) {
      const { userInfo } = store.state.settings;
      if (!userInfo || !userInfo.userId) {
        await store.dispatch("settings/getUserInfo");
        await store.dispatch("settings/getUserMenu");
      }
      if (to.meta.permission === false) {
        //无权访问
        next({ path: "/404", replace: true });
      }
      next();
    } else {
      next("/login");
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

router.onReady(() => {
  /*
   *路由准备完成后添加权限路由
   */
  if (getToken()) {
    router.addRoutes(getRoutes(Storage.get("fm-menu")));
  } else {
    router.push({ path: "/login" });
  }
});

export default router;
